import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import { TPromoBannerPosition } from '@onesource/schemas';
import { useGetPromoBannerForEntity } from '@onesource/services';
import { FC } from 'react';

import { PromoBanner } from './promo-banner';

export interface PromoBannerSlotProps {
  /** The entity (space / sub-space / section / sub-section / lesson) id of the page. */
  entityId?: string;
  /** Which position this slot represents on the page. */
  position: TPromoBannerPosition;
  sx?: SxProps;
}

/**
 * Renders the public promo banner assigned to `entityId`, but only when the
 * banner's configured position matches this slot. Mount one slot per position
 * (header / middle / footer) on a page; only the matching one renders.
 */
export const PromoBannerSlot: FC<PromoBannerSlotProps> = ({ entityId, position, sx }) => {
  const { data: banner } = useGetPromoBannerForEntity(entityId);

  if (!banner) {
    return null;
  }

  if (banner.displayPosition !== position) {
    return null;
  }

  return (
    <Box sx={{ width: '100%', my: 2, ...sx }}>
      <PromoBanner banner={banner} />
    </Box>
  );
};
